import type { QueryApi } from "../../api/query";

export function createUseDiscountCodesByShop($api: QueryApi) {
  return function useDiscountCodesByShop(shopId: string | undefined, options?: { enabled?: boolean }) {
    return $api.useQuery("get", "/discount-codes/byShop/{shopId}", {
      params: { path: { shopId: shopId! } },
    }, {
      staleTime: 60_000,
      enabled: !!shopId && (options?.enabled !== false),
    });
  };
}
